export default __webpack_public_path__ + "static/media/payroll.4d023709.svg";